module.exports = __webpack_public_path__ + "media/error01.c6ca638c.mp3";